
const FETCH_CLASSROOM_START = 'FETCH_CLASSROOM_START'
const FETCH_CLASSROOM_DATA = 'FETCH_CLASSROOM_DATA'

export {
  FETCH_CLASSROOM_START,
  FETCH_CLASSROOM_DATA

}
